import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Ingredient } from '../../../../../../commons/models/ingredient';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { IngredientService } from '../../../../../../commons/services/ingredient.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponent } from '../../../../../shared/components/dialog/dialog.component';
import { LaravelIngredientService } from '../../../../../../commons/services/laravel/laravel-ingredient.service';
import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../../commons/services/alert.service';
import * as IngredientsActions from '../../../../../../store/actions/ingredients.actions';

@Component({
  selector: 'app-new-ingredient',
  templateUrl: './new-ingredient.component.html',
  styleUrls: ['./new-ingredient.component.scss']
})
export class NewIngredientComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  ingredientForm: UntypedFormGroup;
  ingredients: Ingredient;

  // private loadingSubject = new BehaviorSubject<boolean>(false);
  // public loading$ = this.loadingSubject.asObservable();

  constructor(
    private store$: Store<AppState>,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    //this.createForm();
    if (this.data) {
      this.ingredients = this.data.ingredient;
    }

    this.createForm();
    this.ngOnChanges();

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  createForm() {
    const ingredientGroup = {
      name: ["", Validators.required],
      additionPrice: ["", Validators.required],
      minusPrice: ["", Validators.required],
      description: [""],
      // type: [""]
    };

    this.ingredientForm = this.fb.group(ingredientGroup);
  }

  ngOnChanges() {
    if (this.ingredientForm) {
      this.ingredientForm.reset();

      this._initFormValues(this.ingredient);

    }
  }

  private _initFormValues(ingredient?: Ingredient) {
    if (ingredient) {
      this.ingredientForm.patchValue({
        name: ingredient.name,
        description: ingredient.description,
        type: ingredient.type,
        additionPrice: ingredient.additionPrice,
        minusPrice: ingredient.minusPrice,
      });
    } else {
      this.ingredientForm.markAllAsTouched();
    }
  }

  cancel() {
    // Verifica se il form ha modifiche
    if (this.ingredientForm.dirty) {
      // Se ci sono modifiche, mostra il dialog di conferma
      this.store$.dispatch(IngredientsActions.requestCloseIngredientsDialog());
    } else {
      // Se il form è pristine (nessuna modifica), chiudi
      this.store$.dispatch(IngredientsActions.closeIngredientsDialog());
    }
  }
  

  private _prepareSaveIngredient(): Ingredient {
    return Ingredient.fromFormGroup(this.ingredientForm, this.ingredient);
  }

  save() {
    let unsavedEntity = this._prepareSaveIngredient();
    this.store$.dispatch(IngredientsActions.saveIngredient({ ingredient: unsavedEntity }));
  }


  revert() {
    this.ngOnChanges();
  }

  deleteIngredient() {
    if (this.ingredients) {
      this.store$.dispatch(IngredientsActions.deleteIngredient({ ingredient: this.ingredients.toDTO() }));
    }
  }


  get ingredient(): Ingredient {
      return this.ingredients;
    }

  set ingredient(ingredient: Ingredient) {
    this.ingredients = ingredient;
    this.ngOnChanges();
  }
}
